export const toStringList = ({ value }: { value: unknown }): unknown => {
	if (value === undefined || value === null || value === '') {
		return undefined;
	}
	const list = Array.isArray(value) ? value : String(value).split(',');

	return list.map((item) => String(item).trim()).filter(Boolean);
};
